<div
  class="form-field-container"
>
  <div [ngClass]="labelTextTransformNone ? 'input-field-name-none': 'input-field-name'" *ngIf="labelName">
    {{ labelName}}<span class="optional" *ngIf="!isRequiredField && showOptionalLabel">({{ OPTIONAL }})</span>
    <span style="margin-left: 8px;" *ngIf="tooltiptxt" [ngbTooltip]=tooltiptxt placement="right" >
      <em
      class="fa fa-info-circle info-icon"
    ></em></span>
  </div>
  <span class="radio-btn-container">
    <input
      class="radio-button"
      type="radio"
      [id]="radioBtnName + 'radio_yes'"
      [name]="radioBtnName"
      [formControl]="inputFormControl"
      [checked]="inputFormControl && inputFormControl.value === '1'"
      [value]="'1'"
    /><label
    class="radio-button-text"
    [for]="radioBtnName + 'radio_yes'"
    >
    yes
  </label>
  </span>
  <span class="radio-btn-container">
    <input
      class="radio-button"
      type="radio"
      [name]="radioBtnName"
      [id]="radioBtnName + 'radio_no'"
      [formControl]="inputFormControl"
      [checked]="inputFormControl && inputFormControl.value === '0'"
      [value]="'0'"
    />
    <label
      class="radio-button-text"
      [for]="radioBtnName + 'radio_no'"
      *ngIf="!readOnlyMode"
      >
      no
    </label>
  </span>
  <div *ngIf="showCommentIcon" class="comment-icon">
    <app-button [type]="(commentObject && commentObject.value && commentObject.value.length) ? 'commented-icon' : 'comment-icon' " (btnClick)="onShowComment.emit()" [disable]="disableComments"></app-button>
  </div>

  <div
    [ngClass]="labelTextTransformNone ? 'error-none': 'error'"
    *ngIf="
      inputFormControl &&
      !readOnlyMode &&
      (submitted || inputFormControl.touched) &&
      inputFormControl.errors
    "
  >
    <div *ngIf="inputFormControl.errors.required">
      {{ labelName }} is required.
    </div>
  </div>
</div>
